export default "/images/vendor/flag-icon-css/flags/1x1/il.svg?2bb2ff50cd3adc1d0cd88e78539a7c25";